import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  FormControl
} from '@angular/forms';
import {
  Area,
  ContentApiService,
  DocumentType
} from '../../services/content-api/content-api.service';
import { TenantApiService } from '../../services/tenant-api/tenant-api.service';
import { Department } from '../../models/sdk-interfaces';
import { UserPrivilegesService } from '../../services/auth-privileges/auth-privileges.service';
import { Bind } from 'primeng/bind';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { TranslatePipe } from '@ngx-translate/core';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'app-batch-settings',
  templateUrl: './batch-settings.component.html',
  styleUrl: './batch-settings.component.scss',
  imports: [FormsModule, ReactiveFormsModule, Bind, InputText, Select, TranslatePipe, AutoComplete]
})
export class BatchSettingsComponent implements OnInit {
  private fb = inject(FormBuilder);
  private contentService = inject(ContentApiService);
  private tenantService = inject(TenantApiService);
  private userPrivilegesService = inject(UserPrivilegesService);

  @Input() batchFormGroup: FormGroup = this.fb.group({
    name: [''],
    department: [''],
    defaultArea: [''],
    defaultDocumentType: [''],
    batchId: ['']
  });
  @Input() tenantId: string = '';
  @Input() showBatchId: boolean = true;
  @Input() isEditing: boolean = false;
  @Input() departmentsPrivs: string = 'CREATE_BATCH';

  documentTypes: DocumentType[] = [];
  areas: Area[] = [];
  filteredDocumentTypes: DocumentType[] = [];
  departments: Department[] = [];

  /**
   *
   */
  ngOnInit(): void {
    this.batchFormGroup.get('department')?.setValidators(Validators.required);

    this.userPrivilegesService
      .getDepartmentsByPrivilege(this.departmentsPrivs)
      .subscribe(departments => {
        this.departments = departments.sort((a, b) => a.name.localeCompare(b.name));
      });

    this.tenantService.getTenantUrls(this.tenantId).subscribe(tenantUrls => {
      this.contentService.setBaseUrl(tenantUrls.contentApiUrl);
      this.contentService.getDocumentTypes().subscribe(docTypes => {
        if (docTypes) {
          this.documentTypes = docTypes;
          this.initFormData();
        }
      });

      this.contentService.getAreas().subscribe(areas => {
        if (areas) {
          this.areas = areas.sort((a, b) => a.name.localeCompare(b.name));
        }
      });

      this.batchFormGroup.get('defaultArea')?.valueChanges.subscribe(area => {
        this.batchFormGroup.get('defaultDocumentType')?.reset();
        this.filterDocTypesByArea(area);
      });
    });
  }

  /**
   * function to filter docTypes and initialize form data
   */
  initFormData(): void {
    if (this.batchFormGroup.getRawValue().defaultArea) {
      this.filterDocTypesByArea(this.batchFormGroup.getRawValue().defaultArea);
      if (this.batchFormGroup.getRawValue().defaultDocumentType) {
        const currentDocType = this.filteredDocumentTypes.find(
          docType => docType.code === this.batchFormGroup.getRawValue().defaultDocumentType
        );
        this.batchFormGroup.get('defaultDocumentType')?.setValue(currentDocType?.code);
      }
    }
  }

  /**
   * function to filter docTypes and initialize form data
   * @param area string area code to filter docTpes by
   */
  filterDocTypesByArea(area: string): void {
    this.filteredDocumentTypes = this.documentTypes.filter(
      documentType => documentType.areaCode === area
    );
  }
}
